module.exports = __webpack_public_path__ + "static/media/1f30d.81aad1ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f30d.svg
// module id = 637
// module chunks = 1